var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotification(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 23 24.4",
    style: {
      enableBackground: "new 0 0 23 24.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#747474;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_129",
    transform: "translate(0.019 0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_133",
    transform: "translate(0.481 0.481)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_478",
    className: "st0",
    d: "M13.1,20.2c0.4,0,0.8,0.4,0.8,0.8c0,0.1,0,0.2-0.1,0.4c-0.9,1.7-2.9,2.3-4.6,1.5 c-0.6-0.3-1.1-0.8-1.5-1.5c-0.2-0.4,0-0.9,0.4-1.1c0.1-0.1,0.2-0.1,0.4-0.1L13.1,20.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_480",
    className: "st0",
    d: "M18.6,7.6V7.3C18.4,3.1,15-0.1,10.8,0C6.7-0.1,3.3,3.1,3.1,7.3v0.5c-0.1,1.9-0.9,3.7-2.2,5 C0.3,13.4,0,14.2,0,15.1v0.5c0.1,1.7,1.4,3,3.1,2.9h15.8c1.7,0,3.1-1.3,3.1-3v-0.4c0-0.9-0.4-1.8-1-2.4 C19.5,11.4,18.6,9.6,18.6,7.6z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.5c9e5cd368e75f3d1d663addc5770baf.svg";
export { ForwardRef as ReactComponent };